import type { WorkflowGraph } from 'model/xyflowMapping';
import { storage } from 'lib/storage';
import { STORAGE_KEYS } from 'lib/storageKeys';

const getCacheKey = (workflowId: string): string =>
  `${STORAGE_KEYS.workflowCachePrefix}${workflowId}`;

export const loadCachedGraph = (workflowId: string): WorkflowGraph | null =>
  storage.get<WorkflowGraph>(getCacheKey(workflowId));

export const saveCachedGraph = (workflowId: string, graph: WorkflowGraph): void => {
  storage.set(getCacheKey(workflowId), graph);
};

export const clearCachedGraph = (workflowId: string): void => {
  storage.remove(getCacheKey(workflowId));
};

/**
 * Clear every cached workflow graph. Currently unused by app code but
 * exposed for an eventual "reset all" UI gesture.
 */
export const clearAllCachedGraphs = (): void => {
  storage.clearByPrefix(STORAGE_KEYS.workflowCachePrefix);
};
